import React, { useState, useEffect } from 'react';
import '../MotorradForms.css';
import { sendFrontAction } from '../services/api';

const MotorradTestDrive = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '+998 ', // Инициализируем с маской кода
        bikeModel: 'BMW S 1000 XR',
        experience: 'Нет стажа / Новичок',
        date: ''
    });

    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({}); 
    const [minDateTime, setMinDateTime] = useState('');

    // Стейт для красивого модального окна
    const [modal, setModal] = useState({
        isOpen: false,
        type: 'success',
        title: '',
        text: ''
    });

    useEffect(() => {
        window.scroll(0, 0);
        
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        
        setMinDateTime(`${year}-${month}-${day}T${hours}:${minutes}`);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'phone') {
            // Защита маски кода страны
            if (!value.startsWith('+998 ')) {
                setFormData({ ...formData, phone: '+998 ' });
                return;
            }
            const rawDigits = value.slice(5);
            const cleanDigits = rawDigits.replace(/[^\d\s\-]/g, '');
            setFormData({ ...formData, phone : `+998 ${cleanDigits}`});
        } else {
            setFormData({ ...formData, [name]: value });
        }

        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const nameRegex = /^[a-zA-Zа-яА-ЯёЁ\s\-]{2,50}$/;
        
        if (!formData.name.trim()) {
            newErrors.name = 'Имя обязательно для заполнения';
        } else if (!nameRegex.test(formData.name.trim())) {
            newErrors.name = 'Имя может содержать только буквы (минимум 2 символа)';
        }

        const numbersOnly = formData.phone.replace(/\D/g, ''); 
        const digitsAfterCode = numbersOnly.slice(3); 

        if (!formData.phone || formData.phone.trim() === '+998') {
            newErrors.phone = 'Номер телефона обязателен';
        } else if (digitsAfterCode.length > 9) {
            newErrors.phone = `Вы ввели лишние цифры (всего ${digitsAfterCode.length} вместо 9).`;
        } else if (digitsAfterCode.length < 9) {
            newErrors.phone = `Номер слишком короткий (всего ${digitsAfterCode.length} из 9 цифр).`;
        }

        if (!formData.date) {
            newErrors.date = 'Выберите желаемую дату и время';
        } else {
            const selectedDate = new Date(formData.date);
            const currentDate = new Date();
            if (selectedDate < currentDate) {
                newErrors.date = 'Нельзя записаться на прошедшую дату или время';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');

        if (!validateForm()) {
            setMessage('❌ Пожалуйста, исправьте ошибки в форме.');
            return;
        }

        setMessage('Отправка данных...');

        const dataToSend = {
            ...formData,
            phone: formData.phone.replace(/\s+/g, '') // Чистим пробелы перед отправкой
        };

        try {
            const result = await sendFrontAction('motorrad_testdrive', dataToSend);
            
            if (result.success) {
                setMessage('');
                // Вызываем премиальное модальное окно успеха
                setModal({
                    isOpen: true,
                    type: 'success',
                    title: 'Вы записаны!',
                    text: 'Менеджер BMW Motorrad свяжется c вами для подтверждения времени визита.'
                });

                setErrors({});
                setFormData({
                    name: '',
                    phone: '+998 ',
                    bikeModel: 'BMW S 1000 XR',
                    experience: 'Нет стажа / Новичок',
                    date: ''
                });
            } else {
                setMessage('');
                setModal({
                    isOpen: true,
                    type: 'error',
                    title: 'Внимание',
                    text: result.message || 'Не удалось завершить регистрацию.'
                });
                if (result.errors) {
                    setErrors(result.errors);
                }
            }
        } catch (error) {
            setMessage('');
            setModal({
                isOpen: true,
                type: 'error',
                title: 'Ошибка соединения',
                text: error.message || 'Что-то пошло не так. Проверьте интернет-соединение.'
            });
        }
    };
    

    return (
        <div className="form-page-wrapper test-drive-bg">
            <div className="form-container-box">
                <div className="form-header-zone">
                    <h1>ЗАПИСЬ <span className="highlight-text">НА ТЕСТ-ДРАЙВ</span></h1>
                    <p>Ощутите всю мощь и динамику мотоциклов BMW в реальных условиях</p>
                </div>

                {message && <div className="form-status-alert error">{message}</div>}

                <form onSubmit={handleSubmit} className="premium-form" noValidate>
                    <div className="form-group-row">

                        <div className={`input-field ${errors.name ? 'has-error' : ''}`}>
                            <label>Ваше имя *</label>
                            <input 
                                type="text" 
                                name="name" 
                                required 
                                placeholder="Александр" 
                                value={formData.name} 
                                onChange={handleChange}
                            />
                            {errors.name && <span className="error-text-hint">{errors.name}</span>}
                        </div>

                        <div className={`input-field ${errors.phone ? 'has-error' : ''}`}>
                            <label>Номер телефона *</label>
                            <input 
                                type="tel" 
                                name="phone" 
                                required 
                                placeholder="+998 90 123 45 67" 
                                value={formData.phone} 
                                onChange={handleChange}
                            />
                            {errors.phone && <span className="error-text-hint">{errors.phone}</span>}
                        </div>

                    </div>

                    <div className="form-group-row">

                        <div className="input-field">
                            <label>Выберите модель для теста</label>
                            <select name="bikeModel" value={formData.bikeModel} onChange={handleChange}>
                                <option>BMW S 1000 RR</option>
                                <option>BMW S 1000 R</option>
                                <option>BMW F 900 R</option>
                                <option>BMW R 1300 RT</option>
                                <option>BMW R 1300 GS Adventure</option>
                            </select>
                        </div>

                        <div className="input-field">
                            <label>Стаж вождения мотоцикла</label>
                            <select name="experience" value={formData.experience} onChange={handleChange}>
                                <option>Нет стажа / Новичок</option>
                                <option>До 1 года</option>
                                <option>От 1 до 3 лет</option>
                                <option>Более 3-х лет</option>
                            </select>
                        </div>
                        
                    </div>

                    <div className={`input-field ${errors.date ? 'has-error' : ''}`}>
                        <label>Желаемая дата и время теста *</label>
                        <input 
                            type="datetime-local" 
                            name="date" 
                            required 
                            min={minDateTime} 
                            value={formData.date} 
                            onChange={handleChange} 
                        />
                        {errors.date && <span className="error-text-hint">{errors.date}</span>}
                    </div>

                    <button type="submit" className="form-submit-btn blue-theme">ЗАПИСАТЬСЯ НА ТЕСТ-ДРАЙВ</button>
                </form>
            </div>

            {/* ВСПЛЫВАЮЩЕЕ ОКНО (MODAL) */}
            {modal.isOpen && (
                <div className="modal-overlay">
                    <div className="modal-card">
                        <div className={`modal-icon-wrap ${modal.type === 'error' ? 'error-theme' : ''}`}>
                            {modal.type === 'success' ? '✓' : '✕'}
                        </div>
                        <h2>{modal.title}</h2>
                        <p>{modal.text}</p>
                        <button className="modal-close-btn" onClick={() => setModal({ ...modal, isOpen: false })}>
                            Закрыть
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MotorradTestDrive;